/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckMailExistence200Response,
  CheckUserIdExistence200Response,
  ResetPasswordRequest,
  ResetPasswordSendMailRequest,
  SendVerifyMailRequest,
  SignupModel,
  SignupRequestModel,
  StripeCustomerModel,
  StripeCustomerRequestModel,
  UpdateUserIdRequest,
  UpdateUserMailAddressRequest,
  UpdateUserPasswordRequest,
  UserMissionItemModel,
  UserModel,
  UserSettingModel,
  UserSettingRequestModel,
  VerifyMailRequest,
  WithdrawalRequestModel,
} from '../models/index';
import {
    CheckMailExistence200ResponseFromJSON,
    CheckMailExistence200ResponseToJSON,
    CheckUserIdExistence200ResponseFromJSON,
    CheckUserIdExistence200ResponseToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    ResetPasswordSendMailRequestFromJSON,
    ResetPasswordSendMailRequestToJSON,
    SendVerifyMailRequestFromJSON,
    SendVerifyMailRequestToJSON,
    SignupModelFromJSON,
    SignupModelToJSON,
    SignupRequestModelFromJSON,
    SignupRequestModelToJSON,
    StripeCustomerModelFromJSON,
    StripeCustomerModelToJSON,
    StripeCustomerRequestModelFromJSON,
    StripeCustomerRequestModelToJSON,
    UpdateUserIdRequestFromJSON,
    UpdateUserIdRequestToJSON,
    UpdateUserMailAddressRequestFromJSON,
    UpdateUserMailAddressRequestToJSON,
    UpdateUserPasswordRequestFromJSON,
    UpdateUserPasswordRequestToJSON,
    UserMissionItemModelFromJSON,
    UserMissionItemModelToJSON,
    UserModelFromJSON,
    UserModelToJSON,
    UserSettingModelFromJSON,
    UserSettingModelToJSON,
    UserSettingRequestModelFromJSON,
    UserSettingRequestModelToJSON,
    VerifyMailRequestFromJSON,
    VerifyMailRequestToJSON,
    WithdrawalRequestModelFromJSON,
    WithdrawalRequestModelToJSON,
} from '../models/index';

export interface CheckMailExistenceRequest {
    mail: string;
}

export interface CheckUserIdExistenceRequest {
    userId: string;
}

export interface CreateOrUpdateStripeCustomerRequest {
    xComiciUserTokenRequired: string;
    stripeCustomerRequestModel: StripeCustomerRequestModel;
}

export interface DeleteStripeCustomerRequest {
    xComiciUserTokenRequired: string;
}

export interface EditUserProfileRequest {
    xComiciUserTokenRequired: string;
    imageFile?: Blob;
    nickname?: string;
    profile?: string;
}

export interface GetStripeCustomerRequest {
    xComiciUserTokenRequired: string;
}

export interface GetUserSettingsRequest {
    xComiciUserTokenRequired: string;
}

export interface MailStopRequest {
    xComiciUserTokenRequired: string;
    noticeType: MailStopNoticeTypeEnum;
}

export interface ResetPasswordOperationRequest {
    token: string;
    resetPasswordRequest: ResetPasswordRequest;
}

export interface ResetPasswordSendMailOperationRequest {
    resetPasswordSendMailRequest?: ResetPasswordSendMailRequest;
}

export interface SendVerifyMailOperationRequest {
    xComiciUserTokenRequired: string;
    sendVerifyMailRequest: SendVerifyMailRequest;
}

export interface UpdateAccountSettingsRequest {
    xComiciUserTokenRequired: string;
    userSettingRequestModel: UserSettingRequestModel;
}

export interface UpdateUserIdOperationRequest {
    xComiciUserTokenRequired: string;
    updateUserIdRequest: UpdateUserIdRequest;
}

export interface UpdateUserMailAddressOperationRequest {
    xComiciUserTokenRequired: string;
    updateUserMailAddressRequest: UpdateUserMailAddressRequest;
}

export interface UpdateUserPasswordOperationRequest {
    xComiciUserTokenRequired: string;
    updateUserPasswordRequest: UpdateUserPasswordRequest;
}

export interface UserSignupRequest {
    userAgent: string;
    signupRequestModel?: SignupRequestModel;
}

export interface UserWithdrawalRequest {
    xComiciUserTokenRequired: string;
    withdrawalRequestModel?: WithdrawalRequestModel;
}

export interface VerifyMailOperationRequest {
    verifyMailRequest?: VerifyMailRequest;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * メールアドレスが既に登録されているものかどうかを確認する
     * メールアドレスの重複を確認する
     */
    async checkMailExistenceRaw(requestParameters: CheckMailExistenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckMailExistence200Response>> {
        if (requestParameters.mail === null || requestParameters.mail === undefined) {
            throw new runtime.RequiredError('mail','Required parameter requestParameters.mail was null or undefined when calling checkMailExistence.');
        }

        const queryParameters: any = {};

        if (requestParameters.mail !== undefined) {
            queryParameters['mail'] = requestParameters.mail;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/checkDuplicateEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckMailExistence200ResponseFromJSON(jsonValue));
    }

    /**
     * メールアドレスが既に登録されているものかどうかを確認する
     * メールアドレスの重複を確認する
     */
    async checkMailExistence(requestParameters: CheckMailExistenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckMailExistence200Response> {
        const response = await this.checkMailExistenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザーIDが既に登録されているものかどうかを確認する
     * ユーザーIDの重複を確認する
     */
    async checkUserIdExistenceRaw(requestParameters: CheckUserIdExistenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckUserIdExistence200Response>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling checkUserIdExistence.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/checkDuplicateUserId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckUserIdExistence200ResponseFromJSON(jsonValue));
    }

    /**
     * ユーザーIDが既に登録されているものかどうかを確認する
     * ユーザーIDの重複を確認する
     */
    async checkUserIdExistence(requestParameters: CheckUserIdExistenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckUserIdExistence200Response> {
        const response = await this.checkUserIdExistenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stripeから取得した情報をstripeCustomerに登録または更新する
     * stripeCustomer情報を登録または更新する
     */
    async createOrUpdateStripeCustomerRaw(requestParameters: CreateOrUpdateStripeCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling createOrUpdateStripeCustomer.');
        }

        if (requestParameters.stripeCustomerRequestModel === null || requestParameters.stripeCustomerRequestModel === undefined) {
            throw new runtime.RequiredError('stripeCustomerRequestModel','Required parameter requestParameters.stripeCustomerRequestModel was null or undefined when calling createOrUpdateStripeCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/stripeCustomer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StripeCustomerRequestModelToJSON(requestParameters.stripeCustomerRequestModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripeから取得した情報をstripeCustomerに登録または更新する
     * stripeCustomer情報を登録または更新する
     */
    async createOrUpdateStripeCustomer(requestParameters: CreateOrUpdateStripeCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrUpdateStripeCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * 支払いタイプがクレジットカードであるstripeCustomer情報を削除する
     * 支払いタイプがクレジットカードであるstripeCustomer情報を削除する
     */
    async deleteStripeCustomerRaw(requestParameters: DeleteStripeCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling deleteStripeCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/stripeCustomer`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 支払いタイプがクレジットカードであるstripeCustomer情報を削除する
     * 支払いタイプがクレジットカードであるstripeCustomer情報を削除する
     */
    async deleteStripeCustomer(requestParameters: DeleteStripeCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStripeCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザープロフィール更新
     */
    async editUserProfileRaw(requestParameters: EditUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling editUserProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.imageFile !== undefined) {
            formParams.append('imageFile', requestParameters.imageFile as any);
        }

        if (requestParameters.nickname !== undefined) {
            formParams.append('nickname', requestParameters.nickname as any);
        }

        if (requestParameters.profile !== undefined) {
            formParams.append('profile', requestParameters.profile as any);
        }

        const response = await this.request({
            path: `/v1/accounts/prifile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModelFromJSON(jsonValue));
    }

    /**
     * ユーザープロフィール更新
     */
    async editUserProfile(requestParameters: EditUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModel> {
        const response = await this.editUserProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 支払いタイプがクレジットカードであるstripeCustomer情報を取得する
     * 支払いタイプがクレジットカードであるstripeCustomer情報を取得する
     */
    async getStripeCustomerRaw(requestParameters: GetStripeCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCustomerModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getStripeCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/stripeCustomer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeCustomerModelFromJSON(jsonValue));
    }

    /**
     * 支払いタイプがクレジットカードであるstripeCustomer情報を取得する
     * 支払いタイプがクレジットカードであるstripeCustomer情報を取得する
     */
    async getStripeCustomer(requestParameters: GetStripeCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCustomerModel> {
        const response = await this.getStripeCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されているユーザー設定情報を取得します。  取得される情報はユーザー設定のみを含みます。
     * ユーザー設定情報を取得する
     */
    async getUserSettingsRaw(requestParameters: GetUserSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSettingModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getUserSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSettingModelFromJSON(jsonValue));
    }

    /**
     * 配信されているユーザー設定情報を取得します。  取得される情報はユーザー設定のみを含みます。
     * ユーザー設定情報を取得する
     */
    async getUserSettings(requestParameters: GetUserSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSettingModel> {
        const response = await this.getUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 通知メールを停止する
     * 通知メールの停止
     */
    async mailStopRaw(requestParameters: MailStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling mailStop.');
        }

        if (requestParameters.noticeType === null || requestParameters.noticeType === undefined) {
            throw new runtime.RequiredError('noticeType','Required parameter requestParameters.noticeType was null or undefined when calling mailStop.');
        }

        const queryParameters: any = {};

        if (requestParameters.noticeType !== undefined) {
            queryParameters['noticeType'] = requestParameters.noticeType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/mailNotification`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 通知メールを停止する
     * 通知メールの停止
     */
    async mailStop(requestParameters: MailStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailStopRaw(requestParameters, initOverrides);
    }

    /**
     * メールに送信したトークンでパスワードをリセットする
     * パスワードリセット実行
     */
    async resetPasswordRaw(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling resetPassword.');
        }

        if (requestParameters.resetPasswordRequest === null || requestParameters.resetPasswordRequest === undefined) {
            throw new runtime.RequiredError('resetPasswordRequest','Required parameter requestParameters.resetPasswordRequest was null or undefined when calling resetPassword.');
        }

        const queryParameters: any = {};

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/password/reset`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メールに送信したトークンでパスワードをリセットする
     * パスワードリセット実行
     */
    async resetPassword(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * パスワードをリセットするメール送信
     * パスワードリセットメール送信
     */
    async resetPasswordSendMailRaw(requestParameters: ResetPasswordSendMailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/password/reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordSendMailRequestToJSON(requestParameters.resetPasswordSendMailRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * パスワードをリセットするメール送信
     * パスワードリセットメール送信
     */
    async resetPasswordSendMail(requestParameters: ResetPasswordSendMailOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetPasswordSendMailRaw(requestParameters, initOverrides);
    }

    /**
     * メールアドレスを認証するためのメールをユーザーに送信します
     * メールアドレス認証メールの送信
     */
    async sendVerifyMailRaw(requestParameters: SendVerifyMailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling sendVerifyMail.');
        }

        if (requestParameters.sendVerifyMailRequest === null || requestParameters.sendVerifyMailRequest === undefined) {
            throw new runtime.RequiredError('sendVerifyMailRequest','Required parameter requestParameters.sendVerifyMailRequest was null or undefined when calling sendVerifyMail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/sendVerifyMail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendVerifyMailRequestToJSON(requestParameters.sendVerifyMailRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メールアドレスを認証するためのメールをユーザーに送信します
     * メールアドレス認証メールの送信
     */
    async sendVerifyMail(requestParameters: SendVerifyMailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendVerifyMailRaw(requestParameters, initOverrides);
    }

    /**
     * 受け取ったリクエストパラメータでユーザー情報を更新します。 更新内容に生まれ年や性別が含まれていた場合は、`生まれ年と性別を登録する` ミッションの進捗管理と達成状況を確認します。 必要であればミッション報酬を付与します。
     * ユーザー設定情報を更新する
     */
    async updateAccountSettingsRaw(requestParameters: UpdateAccountSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMissionItemModel>>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling updateAccountSettings.');
        }

        if (requestParameters.userSettingRequestModel === null || requestParameters.userSettingRequestModel === undefined) {
            throw new runtime.RequiredError('userSettingRequestModel','Required parameter requestParameters.userSettingRequestModel was null or undefined when calling updateAccountSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserSettingRequestModelToJSON(requestParameters.userSettingRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMissionItemModelFromJSON));
    }

    /**
     * 受け取ったリクエストパラメータでユーザー情報を更新します。 更新内容に生まれ年や性別が含まれていた場合は、`生まれ年と性別を登録する` ミッションの進捗管理と達成状況を確認します。 必要であればミッション報酬を付与します。
     * ユーザー設定情報を更新する
     */
    async updateAccountSettings(requestParameters: UpdateAccountSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMissionItemModel>> {
        const response = await this.updateAccountSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザID（username）の変更
     * ユーザID（username）の変更
     */
    async updateUserIdRaw(requestParameters: UpdateUserIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling updateUserId.');
        }

        if (requestParameters.updateUserIdRequest === null || requestParameters.updateUserIdRequest === undefined) {
            throw new runtime.RequiredError('updateUserIdRequest','Required parameter requestParameters.updateUserIdRequest was null or undefined when calling updateUserId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/userId`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserIdRequestToJSON(requestParameters.updateUserIdRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザID（username）の変更
     * ユーザID（username）の変更
     */
    async updateUserId(requestParameters: UpdateUserIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserIdRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザーのメールアドレスを変更する
     * メールアドレス更新
     */
    async updateUserMailAddressRaw(requestParameters: UpdateUserMailAddressOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling updateUserMailAddress.');
        }

        if (requestParameters.updateUserMailAddressRequest === null || requestParameters.updateUserMailAddressRequest === undefined) {
            throw new runtime.RequiredError('updateUserMailAddressRequest','Required parameter requestParameters.updateUserMailAddressRequest was null or undefined when calling updateUserMailAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/mailAddress`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserMailAddressRequestToJSON(requestParameters.updateUserMailAddressRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザーのメールアドレスを変更する
     * メールアドレス更新
     */
    async updateUserMailAddress(requestParameters: UpdateUserMailAddressOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserMailAddressRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザーのパスワードの変更
     * ユーザーのパスワードの変更
     */
    async updateUserPasswordRaw(requestParameters: UpdateUserPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling updateUserPassword.');
        }

        if (requestParameters.updateUserPasswordRequest === null || requestParameters.updateUserPasswordRequest === undefined) {
            throw new runtime.RequiredError('updateUserPasswordRequest','Required parameter requestParameters.updateUserPasswordRequest was null or undefined when calling updateUserPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/password`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserPasswordRequestToJSON(requestParameters.updateUserPasswordRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザーのパスワードの変更
     * ユーザーのパスワードの変更
     */
    async updateUserPassword(requestParameters: UpdateUserPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * ユーザの会員登録する
     * 会員登録する
     */
    async userSignupRaw(requestParameters: UserSignupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignupModel>> {
        if (requestParameters.userAgent === null || requestParameters.userAgent === undefined) {
            throw new runtime.RequiredError('userAgent','Required parameter requestParameters.userAgent was null or undefined when calling userSignup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.userAgent !== undefined && requestParameters.userAgent !== null) {
            headerParameters['User-Agent'] = String(requestParameters.userAgent);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/signup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignupRequestModelToJSON(requestParameters.signupRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignupModelFromJSON(jsonValue));
    }

    /**
     * ユーザの会員登録する
     * 会員登録する
     */
    async userSignup(requestParameters: UserSignupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignupModel> {
        const response = await this.userSignupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ユーザーの退会を登録する
     * ユーザー退会
     */
    async userWithdrawalRaw(requestParameters: UserWithdrawalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling userWithdrawal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/withdrawal`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: WithdrawalRequestModelToJSON(requestParameters.withdrawalRequestModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ユーザーの退会を登録する
     * ユーザー退会
     */
    async userWithdrawal(requestParameters: UserWithdrawalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userWithdrawalRaw(requestParameters, initOverrides);
    }

    /**
     * メールに届いたトークンでメール認証を行います
     * メール認証承認
     */
    async verifyMailRaw(requestParameters: VerifyMailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/activate/{token}`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyMailRequestToJSON(requestParameters.verifyMailRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メールに届いたトークンでメール認証を行います
     * メール認証承認
     */
    async verifyMail(requestParameters: VerifyMailOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyMailRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const MailStopNoticeTypeEnum = {
    News: 'news',
    Newepisode: 'newepisode',
    Follow: 'follow',
    Comment: 'comment',
    Support: 'support',
    Message: 'message',
    Pickup: 'pickup',
    Reserve: 'reserve',
    Comm: 'comm',
    Comici: 'comici'
} as const;
export type MailStopNoticeTypeEnum = typeof MailStopNoticeTypeEnum[keyof typeof MailStopNoticeTypeEnum];
